















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptPurchaseJournal extends Vue {

  public reportTemplate: Common.ReportTemplate = null;
  public baseDate: Date = new Date().getCalendarDate();
  public isStockCommodity: boolean = true;
  public isMinimumStockQuantity: boolean = true;
  public isShortage: boolean = true;
  public onExcelExport :boolean = false;
  public baseDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.SupplementCommodityReportTemplateQuery = new Common.SupplementCommodityReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.baseDate = new Date().getCalendarDate();
    this.isStockCommodity = true;
    this.isMinimumStockQuantity = true;
    this.isShortage = true;
    (this.$refs.SupplementCommodityDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SupplementCommodityReportQuery = new Common.SupplementCommodityReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.baseDate = this.baseDate;
    query.isStockCommodity = this.isStockCommodity;
    query.isMinimumStockQuantity = this.isMinimumStockQuantity;
    query.isShortage = this.isShortage;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
